import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getDatabase, ref, get } from "firebase/database";
import app from "../../backend/firebaseConfig";
import { db } from "../../backend/firebaseConfig";
import {  doc,
          getDoc,
          getDocs,
          collection,
          updateDoc, 
          onSnapshot, } from "firebase/firestore";
// import Customized Components
import {  markNotificationAsRead,
          deleteNotification,
          addNotification } from "../../components/functions/notifyComp";

// Track which users have already been processed in this session
const processedUsers = new Set();

export function notifyFirstUser() {
  const auth = getAuth();
  return onAuthStateChanged(auth, async (user) => {
    if (user) {
      // Prevent multiple simultaneous executions for the same user
      if (processedUsers.has(user.uid)) {
        return;
      }
      processedUsers.add(user.uid);
      
      try {
        // Check if user document exists and welcomeNotificationSent flag
        const userRef = doc(db, "users", user.uid);
        const userDoc = await getDoc(userRef);
        
        if (userDoc.exists()) {
          const userData = userDoc.data();
          
          // Only send welcome notification if it hasn't been sent before
          if (userData.welcomeNotificationSent !== true) {
            // Mark that welcome notification will be sent (optimistic update to prevent race conditions)
            await updateDoc(userRef, {
              welcomeNotificationSent: true
            });
            
            // Send welcome notification
            await addNotification(user.uid, "Welcome! This is your first notification.");
          }
        }
      } catch (error) {
        console.error("Error in notifyFirstUser:", error);
        // Remove from processed set on error to allow retry
        processedUsers.delete(user.uid);
      }
    }
  });
}
